<div class="st-drawer-wrapper opportunities-add-drawer">
  <a href=""></a>
  <!--  Header  -->
  <div class="st-drawer-header">
    <span class="text-header-18 text-semibold">{{ isLead ? 'Crear Nuevo Lead' : 'Crear Nueva Oportunidad' }}</span>
    <app-st-icon (click)="close()" class="text-header-16 cursor-pointer" [name]="'close'" [bold]="true"></app-st-icon>
  </div>

  <!--  Content  -->
  <div class="st-drawer-content">
    <!--  Stepper  -->
    <div class="stepper">
      <div class="stepper-item" [ngClass]="{ active: step === 1 }" (click)="step = 1">
        <span>1. Información General</span>
      </div>

      <app-st-icon name="keyboard_arrow_right"></app-st-icon>

      <div class="stepper-item" [ngClass]="{ active: step === 2, disabled: !isStepOneValid() }"
        (click)="isStepOneValid() && (step = 2)">
        <span>2. Detalles Adicionales</span>
      </div>
    </div>

    <div class="flow-content-wrapper">
      <!-- Step 1: Información General -->
      <form *ngIf="step === 1" class="st-form" nz-form [formGroup]="oportunitiesForm">

        <!-- Bloque: Datos de probabilidad (sin divider) -->
        <div nz-row [nzGutter]="16" style="margin-bottom: 24px;">
          <!--
          <div nz-col [nzXs]="24" [nzSm]="12">
            <nz-form-item>
              <nz-form-label [nzSpan]="24">Probabilidad (%)</nz-form-label>
              <nz-form-control>
                <input type="number" nzSize="large" nz-input formControlName="probability" placeholder="0.00%"
                  step="0.01" min="0" max="100" />
              </nz-form-control>
            </nz-form-item>
          </div>
          -->
        </div>

        <!-- Sección: Información general -->
        <div class="section-container">
          <div class="section-divider">
            <span class="divider-line"></span>
            <span class="section-label">Información general</span>
            <span class="divider-line"></span>
          </div>
          <div class="section-content" style="padding: 16px 0;">
            <nz-form-item style="margin-bottom: 16px;">
              <nz-form-label [nzSpan]="24" nzRequired>Nombre</nz-form-label>
              <nz-form-control [nzErrorTip]="'Este campo es requerido'">
                <input type="text" nzSize="large" nz-input formControlName="name" placeholder="Introduce Nombre..." />
              </nz-form-control>
            </nz-form-item>

            <div nz-row [nzGutter]="16">
              <div nz-col [nzXs]="24" [nzSm]="12" *ngIf="!isLead">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">Tipo de oportunidad</nz-form-label>
                  <nz-form-control>
                    <nz-select nzSize="large" formControlName="opportunityType"
                      [nzPlaceHolder]="'Seleccione tipo de oportunidad'">
                      <nz-option nzValue="Proyecto" nzLabel="Proyecto"></nz-option>
                      <nz-option nzValue="Servicio Puntual" nzLabel="Servicio Puntual"></nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>

              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">Compañia</nz-form-label>
                  <nz-form-control>
                    <nz-select nzSize="large" formControlName="companyId" [nzPlaceHolder]="'Seleccione Compañia'">
                      <nz-option *ngFor="let company of allCompaniesList" [nzValue]="company.id"
                        [nzLabel]="company.name"></nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>

            <div nz-row [nzGutter]="16">
              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">Centro de costo</nz-form-label>
                  <nz-form-control>
                    <nz-select nzSize="large" formControlName="costCenter"
                      [nzPlaceHolder]="'Seleccione centro de costo'" nzShowSearch nzAllowClear>
                      <nz-option *ngFor="let costCenter of costCenterList" [nzValue]="costCenter.id"
                        [nzLabel]="costCenter.name"></nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>

              <div nz-col [nzXs]="24" [nzSm]="12" *ngIf="!isLead">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">Cierre previsto</nz-form-label>
                  <nz-form-control>
                    <nz-input-group nzSize="large" class="addon-after" [nzAddOnAfter]="suffixTmpl">
                      <nz-date-picker nzSize="large" [nzSuffixIcon]="emtySuffixTmpl" class="w-100"
                        formControlName="expectedClosingDate" nzPlaceHolder="Introduce fecha de cierre..."
                        nzFormat="dd-MM-yyyy" [nzDisabledDate]="disabledPastDate"></nz-date-picker>
                    </nz-input-group>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
          </div>
        </div>

        <!-- Sección: Equipo y Asignación -->
        <div class="section-container">
          <div class="section-divider">
            <span class="divider-line"></span>
            <span class="section-label">Equipo y Asignación</span>
            <span class="divider-line"></span>
          </div>
          <div class="section-content" style="padding: 16px 0;">
            <div nz-row [nzGutter]="16">
              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24" nzRequired>Equipo de ventas</nz-form-label>
                  <nz-form-control [nzErrorTip]="'Este campo es requerido'">
                    <nz-select nzSize="large" formControlName="salesTeam"
                      [nzPlaceHolder]="'Seleccione equipo de ventas'"
                      (ngModelChange)="onSalesTeamChange($event)">
                      <nz-option *ngFor="let salesTeam of salesTeamList" [nzValue]="salesTeam.id"
                        [nzLabel]="salesTeam.name"></nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>

              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24" nzRequired>Comercial</nz-form-label>
                  <nz-form-control [nzErrorTip]="'Este campo es requerido'">
                    <app-avatar-select formControlName="commercial" 
                      [options]="filteredCommercialList"
                      [disabled]="!oportunitiesForm.get('salesTeam')?.value || !hasTeamMembers"
                      placeholder="Selecciona el Comercial..."
                      (ngModelChange)="onCommercialChange($event)"></app-avatar-select>
                    <div *ngIf="oportunitiesForm.get('salesTeam')?.value && !hasTeamMembers" 
                      style="margin-top: 8px; color: #999; font-size: 12px;">
                      No hay comerciales disponibles para este equipo
                    </div>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>

            <div nz-row [nzGutter]="16">
              <div nz-col [nzXs]="24" [nzSm]="12" *ngIf="!isLead">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">Proyecto</nz-form-label>
                  <nz-form-control>
                    <nz-select nzSize="large" formControlName="projects" [nzPlaceHolder]="'Seleccione Proyectos'"
                      [nzLoading]="loadingProjects" [nzNotFoundContent]="noAvailableProjectsTmpl"
                      (ngModelChange)="onProjectSelectChange($event)" nzShowSearch nzAllowClear>
                      <nz-option *ngFor="let project of projectsList" [nzValue]="project.id"
                        [nzLabel]="project.name"></nz-option>
                      <nz-option [nzValue]="createProjectOptionValue" nzLabel="Crear proyecto" nzCustomContent>
                        <div class="create-project-option" (click)="openCreateProjectDrawer($event)">
                          <app-st-icon [name]="'add'" [bold]="true"></app-st-icon>
                          <span>Crear proyecto</span>
                        </div>
                      </nz-option>
                    </nz-select>
                    <ng-template #noAvailableProjectsTmpl>
                      <span>No hay resultados</span>
                    </ng-template>
                  </nz-form-control>
                </nz-form-item>
              </div>

              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24"></nz-form-label>
                  <nz-form-control>
                    <!-- Columna reservada (sin campos) para mantener la rejilla -->
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
          </div>
        </div>

      </form>

      <!-- Step 2: Información Adicional -->
      <!-- Step 2: Información Adicional -->
      <form *ngIf="step === 2" class="st-form" nz-form [formGroup]="oportunitiesForm">
        <!-- 2. Sección: Información de Contacto -->
        <!-- <div class="section-container" *ngIf="isLead">
                      <div class="section-divider">
                        <span class="divider-line"></span>
                        <span class="section-label">Información de Contacto</span>
                        <span class="divider-line"></span>
                      </div>
                      <div class="section-content" style="padding: 16px 0;">
                        <div nz-row [nzGutter]="16">
                          <div nz-col [nzXs]="24" [nzSm]="12">
                            <nz-form-item>
                              <nz-form-label [nzSpan]="24">Nombre de la empresa</nz-form-label>
                              <nz-form-control>
                                <input type="text" nzSize="large" nz-input formControlName="clientCompany"
                                  placeholder="Introduce nombre de la empresa..." />
                              </nz-form-control>
                            </nz-form-item>
                          </div>

                          <div nz-col [nzXs]="24" [nzSm]="12">
                            <nz-form-item>
                              <nz-form-label [nzSpan]="24">Nombre del contacto</nz-form-label>
                              <nz-form-control>
                                <input type="text" nzSize="large" nz-input formControlName="contactName"
                                  placeholder="Introduce nombre del contacto..." />
                              </nz-form-control>
                            </nz-form-item>
                          </div>
                        </div>

                        <div nz-row [nzGutter]="16">
                          <div nz-col [nzXs]="24" [nzSm]="12">
                            <nz-form-item>
                              <nz-form-label [nzSpan]="24">Dirección</nz-form-label>
                              <nz-form-control>
                                <input type="text" nzSize="large" nz-input formControlName="street" placeholder="Introduce Dirección..." />
                              </nz-form-control>
                            </nz-form-item>
                          </div>

                          <div nz-col [nzXs]="24" [nzSm]="12">
                            <nz-form-item>
                              <nz-form-label [nzSpan]="24">Puesto de trabajo</nz-form-label>
                              <nz-form-control>
                                <input type="text" nzSize="large" nz-input formControlName="jobTitle"
                                  placeholder="Introduce Puesto de trabajo..." />
                              </nz-form-control>
                            </nz-form-item>
                          </div>
                        </div>

                        <div nz-row [nzGutter]="16">
                          <div nz-col [nzXs]="24" [nzSm]="12">
                            <nz-form-item>
                              <nz-form-label [nzSpan]="24">Sitio web</nz-form-label>
                              <nz-form-control>
                                <input type="text" nzSize="large" nz-input formControlName="website"
                                  placeholder="Introduce URL del sitio..." />
                              </nz-form-control>
                            </nz-form-item>
                          </div>
                        </div>
                      </div>
                    </div> -->
        <!-- 1. Sección: Contacto -->
        <div class="section-container">
          <div class="section-divider">
            <span class="divider-line"></span>
            <span class="section-label">Contacto</span>
            <span class="divider-line"></span>
          </div>
          <div class="section-content" style="padding: 16px 0;">
            <div nz-row [nzGutter]="16">
              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">Empresa intermediaria</nz-form-label>
                  <nz-form-control>
                    <nz-select nzSize="large" formControlName="intermediaryCompanyId"
                      [nzPlaceHolder]="'Seleccione empresa intermediaria'" nzShowSearch nzAllowClear
                      (nzOnSearch)="onIntermediaryCompanySearch($event)">
                      <nz-option *ngFor="let company of filteredIntermediaryCompaniesList" [nzValue]="company.id"
                        [nzLabel]="company.name"></nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24" nzRequired>Empresa cliente</nz-form-label>
                  <nz-form-control [nzErrorTip]="'Este campo es requerido'">
                    <nz-select nzSize="large" formControlName="clientCompany"
                      [nzPlaceHolder]="'Seleccione empresa cliente'" nzShowSearch nzAllowClear
                      (nzOnSearch)="onClientCompanySearch($event)">
                      <nz-option *ngFor="let company of filteredCompaniesList" [nzValue]="company.id"
                        [nzLabel]="company.name"></nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>

              <div nz-col [nzXs]="24" [nzSm]="12" *ngIf="!isLead">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24" nzRequired>Contacto</nz-form-label>
                  <nz-form-control [nzErrorTip]="'Este campo es requerido'">
                    <app-avatar-select 
                      formControlName="contact"
                      [options]="filteredContactList.length > 0 ? filteredContactList : contactList"
                      [createPartnerDrawerComponent]="ModifyPartnerDrawerComponent"
                      [allowCreateNew]="true"
                      [defaultParentId]="oportunitiesForm.get('clientCompany')?.value || null"
                      [defaultIsEmployee]="true"
                      [nzAllowClear]="true"
                      [nzLoading]="contactLoading"
                      placeholder="Selecciona el Contacto..."
                      (partnerCreated)="onPartnerCreated($event)">
                    </app-avatar-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col [nzXs]="24" [nzSm]="12" *ngIf="isLead">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24" nzRequired>Contacto</nz-form-label>
                  <nz-form-control [nzErrorTip]="'Este campo es requerido'">
                    <app-avatar-select 
                      formControlName="contact"
                      [options]="filteredContactList.length > 0 ? filteredContactList : contactList"
                      [createPartnerDrawerComponent]="ModifyPartnerDrawerComponent"
                      [allowCreateNew]="true"
                      [defaultParentId]="oportunitiesForm.get('clientCompany')?.value || null"
                      [defaultIsEmployee]="true"
                      [nzAllowClear]="true"
                      [nzLoading]="contactLoading"
                      placeholder="Selecciona el Contacto..."
                      (partnerCreated)="onPartnerCreated($event)">
                    </app-avatar-select>
                  </nz-form-control>
                </nz-form-item>
              </div>

            </div>

            <div nz-row [nzGutter]="16">
              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">Correo electrónico</nz-form-label>
                  <nz-form-control>
                    <input type="email" nzSize="large" nz-input formControlName="email"
                      placeholder="Introduce Correo electrónico..." />
                  </nz-form-control>
                </nz-form-item>
              </div>

              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">Teléfono</nz-form-label>
                  <nz-form-control>
                    <input type="tel" nzSize="large" nz-input formControlName="phone"
                      placeholder="Introduce número de teléfono..." />
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
            <div nz-row [nzGutter]="16" *ngIf="isLead">
              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">Dirección</nz-form-label>
                  <nz-form-control>
                    <input type="text" nzSize="large" nz-input formControlName="street"
                      placeholder="Introduce Dirección..." />
                  </nz-form-control>
                </nz-form-item>
              </div>

              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">Puesto de trabajo</nz-form-label>
                  <nz-form-control>
                    <input type="text" nzSize="large" nz-input formControlName="jobTitle"
                      placeholder="Introduce Puesto de trabajo..." />
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>

            <div nz-row [nzGutter]="16" *ngIf="isLead">
              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">Sitio web</nz-form-label>
                  <nz-form-control>
                    <input type="text" nzSize="large" nz-input formControlName="website"
                      placeholder="Introduce URL del sitio..." />
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
          </div>
        </div>

        <!-- 2. Sección: Categorización -->
        <div class="section-container">
          <div class="section-divider">
            <span class="divider-line"></span>
            <span class="section-label">Categorización</span>
            <span class="divider-line"></span>
          </div>
          <div class="section-content" style="padding: 16px 0;">
            <div nz-row [nzGutter]="16">
              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">Prioridad</nz-form-label>
                  <nz-form-control>
                    <nz-select nzSize="large" formControlName="priority" [nzPlaceHolder]="'Seleccione prioridad'">
                      <nz-option nzValue="Low" nzLabel="Baja"></nz-option>
                      <nz-option nzValue="Medium" nzLabel="Medio"></nz-option>
                      <nz-option nzValue="High" nzLabel="Alto"></nz-option>
                      <nz-option nzValue="VeryHigh" nzLabel="Muy Alto"></nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>

              <!-- <div nz-col [nzXs]="24" [nzSm]="12">
                      <nz-form-item>
                        <nz-form-label [nzSpan]="24">Etiquetas</nz-form-label>
                        <nz-form-control>
                          <nz-select nzSize="large" formControlName="tags" [nzPlaceHolder]="'Seleccione etiqueta'">
                            <nz-option *ngFor="let tag of tagsList" [nzValue]="tag.id" [nzLabel]="tag.name"></nz-option>
                          </nz-select>
                        </nz-form-control>
                      </nz-form-item>
                    </div> -->
            </div>
          </div>
        </div>

        <!-- 3. Sección: Marketing (solo para Leads) -->
        <div class="section-container" *ngIf="isLead">
          <div class="section-divider">
            <span class="divider-line"></span>
            <span class="section-label">Información adicional</span>
            <span class="divider-line"></span>
          </div>
          <div class="section-content" style="padding: 16px 0;">
            <div nz-row [nzGutter]="16">
              <!-- <div nz-col [nzXs]="24" [nzSm]="12">
                      <nz-form-item>
                        <nz-form-label [nzSpan]="24">Campaña</nz-form-label>
                        <nz-form-control>
                          <input type="text" nzSize="large" nz-input formControlName="campaign"
                            placeholder="Introduce Campaña..." />
                        </nz-form-control>
                      </nz-form-item>
                    </div> -->

              <!-- <div nz-col [nzXs]="24" [nzSm]="12">
                      <nz-form-item>
                        <nz-form-label [nzSpan]="24">Medio</nz-form-label>
                        <nz-form-control>
                          <input type="text" nzSize="large" nz-input formControlName="medium" placeholder="Introduce Medio..." />
                        </nz-form-control>
                      </nz-form-item>
                    </div> -->

              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">Origin</nz-form-label>
                  <nz-form-control>
                    <input type="text" nzSize="large" nz-input formControlName="source"
                      placeholder="Introduce origen..." />
                  </nz-form-control>
                </nz-form-item>
              </div>

              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">Referido por</nz-form-label>
                  <nz-form-control>
                    <nz-select nzSize="large" formControlName="referencedById"
                      [nzPlaceHolder]="'Seleccione partner'" nzShowSearch nzAllowClear>
                      <nz-option *ngFor="let partner of globalValuesService.partnerlist" 
                        [nzValue]="partner.id" 
                        [nzLabel]="(partner.name || '') + ' ' + (partner.surName || '')">
                      </nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>

            <nz-form-item style="margin-top: 16px;">
              <nz-form-label [nzSpan]="24">Descripción</nz-form-label>
              <nz-form-control>
                <quill-editor #quillEditorRef formControlName="description" [modules]="quillModules" [styles]="{height: '200px', width: '100%'}">
                </quill-editor>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <!-- 4. Sección: Análisis (solo para Leads) -->
        <!--  <div class="section-container" *ngIf="isLead">
                <div class="section-divider">
                  <span class="divider-line"></span>
                  <span class="section-label">Análisis</span>
                  <span class="divider-line"></span>
                </div>
                <div class="section-content" style="padding: 16px 0%;">
                  <div nz-row [nzGutter]="16">
                    <div nz-col [nzXs]="24" [nzSm]="12">
                      <nz-form-item>
                        <nz-form-label [nzSpan]="24">Fecha de asignación</nz-form-label>
                        <nz-form-control>
                          <nz-input-group nzSize="large" class="addon-after" [nzAddOnAfter]="suffixTmpl">
                            <nz-date-picker nzSize="large" [nzSuffixIcon]="emtySuffixTmpl" class="w-100"
                              formControlName="dateAssignment" nzPlaceHolder="Introduce fecha de asignación..."
                              nzFormat="dd-MM-yyyy"></nz-date-picker>
                          </nz-input-group>
                        </nz-form-control>
                      </nz-form-item>
                    </div>

                    <div nz-col [nzXs]="24" [nzSm]="12">
                      <nz-form-item>
                        <nz-form-label [nzSpan]="24">Fecha de cierre</nz-form-label>
                        <nz-form-control>
                          <nz-input-group nzSize="large" class="addon-after" [nzAddOnAfter]="suffixTmpl">
                            <nz-date-picker
                              nzSize="large"
                              [nzSuffixIcon]="emtySuffixTmpl"
                              class="w-100"
                              formControlName="dateClose"
                              nzPlaceHolder="Introduce fecha de cierre..."
                              nzFormat="dd-MM-yyyy"
                            ></nz-date-picker>
                          </nz-input-group>
                        </nz-form-control>
                      </nz-form-item>
                    </div>

                    <div nz-col [nzXs]="24" [nzSm]="12" *ngIf="!isLead">
                      <nz-form-item>
                        <nz-form-label [nzSpan]="24">Tipo</nz-form-label>
                        <nz-form-control>
                          <nz-select nzSize="large" formControlName="type" [nzPlaceHolder]="'Seleccione tipo'">
                            <nz-option nzValue="Project" nzLabel="Proyecto"></nz-option>
                            <nz-option nzValue="PunctualService" nzLabel="Servicio Puntual"></nz-option>
                          </nz-select>
                        </nz-form-control>
                      </nz-form-item>
                    </div>
                  </div>
                </div>
              </div> -->

        <!-- 5. Sección: Descripción (como estaba) -->
        <!--  <div class="section-container">
                <div class="section-divider">
                  <span class="divider-line"></span>
                  <span class="section-label">Descripción</span>
                  <span class="divider-line"></span>
                </div>
                <div class="section-content" style="padding: 16px 0;">
                  <nz-form-item>
                    <nz-form-label [nzSpan]="24">Descripción</nz-form-label>
                    <nz-form-control>
                      <textarea type="text" nzSize="large" nz-input formControlName="description" rows="4"
                        placeholder="Introduce Descripción..."></textarea>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div> -->

        <!-- 6. Sección Documentos: ELIMINADA (no se incluye bloque) -->

      </form>
    </div>
  </div>

  <!--  Footer  -->
  <div class="st-drawer-footer" [class.show-border]="step !== 1">
    <button (click)="close()" class="text-btn-14" nz-button nzType="text" nzShape="round" nzSize="large">
      <span>Cancelar</span>
    </button>

    <button *ngIf="step === 1" (click)="step = 2" [disabled]="!isStepOneValid()" class="text-btn-14" nz-button
      nzType="default" nzShape="round" nzSize="large">
      <span>Siguiente</span>
      <app-st-icon class="sufix" [name]="'arrow_forward'" [bold]="true"></app-st-icon>
    </button>

    <div *ngIf="step === 2" class="flex-center gap-200">
      <button [disabled]="savingAndNew || savingAndClose || !oportunitiesForm.valid" (click)="createOpportunity(true)" class="text-btn-14" nz-button
        nzType="default" nzShape="round" nzSize="large">
        <app-st-icon *ngIf="savingAndNew" class="prefix" [name]="'progress_activity'"
          [bold]="true"></app-st-icon>
        <span>Guardar y nuevo</span>
      </button>
      <button [disabled]="savingAndNew || savingAndClose || !oportunitiesForm.valid" (click)="createOpportunity(false)" class="text-btn-14" nz-button
        nzType="primary" nzShape="round" nzSize="large">
        <app-st-icon *ngIf="!savingAndClose" class="prefix" [name]="'add'" [bold]="true"></app-st-icon>
        <app-st-icon *ngIf="savingAndClose" class="prefix" [name]="'progress_activity'"
          [bold]="true"></app-st-icon>
        <span>Guardar y cerrar</span>
      </button>
    </div>
  </div>
</div>

<ng-template #emtySuffixTmpl>
</ng-template>

<ng-template #suffixTmpl>
  <app-st-icon style="font-size: 20px" color="#666666" [bold]="true" name="calendar_today"></app-st-icon>
</ng-template>

<!--  Notification  -->
<ng-template #notificationTmpl>
  <app-toast *ngIf="notRef" [icon]="toastConfig.icon" [iconColor]="toastConfig.iconColor"
    [showUndo]="toastConfig.showUndo" [notRef]="notRef" [content]="toastConfig.content"
    [msg]="toastConfig.msg"></app-toast>
</ng-template>

<!-- Modal de link (nzGetContainer: body para no cortarse con el drawer) -->
<ng-template #linkModalTemplate>
  <div class="link-modal-content">
    <label class="link-modal-label">URL del enlace:</label>
    <input
      #linkInput
      type="text"
      [(ngModel)]="linkModalUrl"
      placeholder="https://ejemplo.com"
      nz-input
      class="link-modal-input"
      (keydown.enter)="onLinkModalEnter()"
    />
  </div>
</ng-template>
<ng-template #linkModalFooterTemplate>
  <div class="link-modal-footer">
    <button nz-button nzType="text" nzShape="round" nzSize="large" (click)="closeLinkModal()">Cancelar</button>
    <button nz-button nzType="primary" nzShape="round" nzSize="large" (click)="onLinkModalConfirm()">Aceptar</button>
  </div>
</ng-template>
